// Shout-out to Ken Burns
(function ($) {

  $.fn.slideshow = function (options) {

    const slides = $(this);

    const settings = $.extend({
      randomize: true,
      slideDuration: 6000,
      fadeDuration: 1000,
      animate: true,
      pauseOnTabBlur: false,
      enableLog: false,
      slideElementClass: 'slide', // Also defined in CSS
      slideshowId: 'slideshow'    // Also defined in CSS
    }, options);

    const slideSelector = `.${settings.slideElementClass}`;

    const log = (...args) => {
      if (settings.enableLog) {
          console.log(...args);
      }
    };


    // Randomize slides
    if (settings.randomize) {

        const slidesDOM = slides[0];

        if (slidesDOM) {

            const slideItems = Array.from(slidesDOM.children);

            // Fisher-Yates shuffle
            for (let i = slideItems.length - 1; i > 0; i--) {

                const randomIndex = Math.floor(
                    Math.random() * (i + 1)
                );

                [slideItems[i], slideItems[randomIndex]] = [
                    slideItems[randomIndex],
                    slideItems[i]
                ];
            }

            // Append shuffled slides back
            slideItems.forEach((slide) => {
                slidesDOM.appendChild(slide);
            });
        }
    }

    // Insert slideshow element
    const slideshow = $('<div>', {
      id: settings.slideshowId
    }).insertBefore(slides);

    // Animation settings
    let cssAnimationDuration = 0;
    if (settings.animate) {
      cssAnimationDuration = settings.slideDuration + settings.fadeDuration;
    } else {
      slides.find(`${slideSelector} div.animate`).removeClass('animate');
    }

    log('Slideshow initialized.');

    // Add the first slide
    const firstSlide = slides.find(`${slideSelector}:first`);

    if (firstSlide.length) {
      firstSlide.find('div.animate').addClass('active').css('animation-duration', `${cssAnimationDuration}ms`);
      firstSlide.prependTo(slideshow);
    }

    // Slideshow state
    let slideshowTimer = null;
    let isPaused = false;

    // Start slideshow timer
    const startSlideshow = () => {
      if (isPaused) return;

      clearTimeout(slideshowTimer);

      slideshowTimer = setTimeout(() => {
        slideRefresh();
        startSlideshow();
      }, settings.slideDuration);
    };

    // Refresh / change slide
    function slideRefresh() {
      log('Slide refresh triggered.');
      const slideshowDOM = slideshow[0];
      if (!slideshowDOM) return;

      // Fallback if slideshow becomes empty
      if (slideshowDOM.children.length === 0) {
        log('There are no slides in the slideshow.');
        const nextSlide = slides.find(`${slideSelector}:first`);

        if (nextSlide.length) nextSlide.prependTo(slideshow); 
        
        return;
      }

      // Add next slide
      const nextSlide = slides.find(`${slideSelector}:first`);
      if (!nextSlide.length) {
        log('No more slides available.');
        return;
      }

      nextSlide.prependTo(slideshow);

      // Activate Ken Burns animation
      const activeSlide = slideshow.find(`${slideSelector}:first`);
      activeSlide.find('div.animate').addClass('active').css('animation-duration', `${cssAnimationDuration}ms`);

      // Fade out previous slide
      const previousSlide = slideshow.find(`${slideSelector}:last`);

      previousSlide.fadeOut(
        settings.fadeDuration,
        function () {
          $(this).find('div.animate').removeClass('active').css('animation-duration', '0ms');
          $(this).appendTo(slides);
          // Make sure all slides are visible
          slides.find(slideSelector).show(0);
        }
      );
    }

    // Start slideshow
    startSlideshow();

    log('Slideshow started.');

    // Pause on browser tab blur
    const handleVisibilityChange = () => {
      if (!settings.pauseOnTabBlur){ return; }

      if (document.hidden) {
        isPaused = true;
        clearTimeout(slideshowTimer);
        log('Slideshow paused.');
      } else {
        isPaused = false;
        startSlideshow();
        log('Slideshow resumed.');
      }
    };

    if (settings.pauseOnTabBlur) {
      document.addEventListener('visibilitychange', handleVisibilityChange);
    }

    // Return plugin instance
    return this;
  };

})(jQuery);